//=include _owl.carousel.min.js
//=include _infinite-ajax-scroll.min.js
//=include _jquery.matchHeight-min.js

$(document).ready(function() {
	var ias = new InfiniteAjaxScroll('.section_realisations', {
		item: '.realisation',
		next: '.next',
		pagination: '.pagination',
		spinner: {
			element: '.spinner',
			show: function(element) {
				element.style.display = 'block';
			},
			hide: function(element) {
				element.style.display = 'none';
			}
		}
	});

	$('.section_realisations').on('mouseover', '.realisation', function() {
		var realisation = $(this);
		var video = realisation.find('video').get(0);
		if (video) {
			video.currentTime = 0;
			video.play();
		}
	});

	$('#carrousel_work').owlCarousel({
		loop: true,
		lazyLoad: true,
		autoWidth: true,
		autoplay: true,
		autoplayTimeout: 4000,
		items: 4,
		margin: 30,
		dots: false,
		nav: false
	});

	$('.section_work .section_work_realisations .realisation_titre').matchHeight({
		byRow: true
	});
});
